import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import List from './list';
import AddDialog from './addDialog';
import ConfirmDialog from 'components/Dialogs/ConfirmDialog';
import * as ItemTypeAction from 'store/actions/item_type';
import { t } from 'i18next';
import AddNewButton from 'components/ActionButtons/addNewButton';

function ItemType() {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [editData, setEditData] = React.useState(null);
  const [showDelete, setShowDelete] = React.useState(false);

  const dispatch = useDispatch();

  const item_types = useSelector((state) => state.other_maintenance.item_types);

  const headers = ['no', 'name', 'created_at', ''];
  React.useEffect(() => {
    dispatch(ItemTypeAction.getAll({}));
  }, [ItemTypeAction.getAll, dispatch]);

  return (
    <>
      <List
        headers={headers}
        data={item_types}
        onEdit={(data) => {
          setModalOpen(true);
          setEditData(data);
        }}
        onDelete={(data) => {
          setShowDelete(true);
          setEditData(data);
        }}
        buttons={
          <>
            <AddNewButton
              onClick={() => {
                setModalOpen(true);
                setEditData(null);
              }}
              type='cargo_group'
            />
            <Button style={{ width: 95 }} size='sm' onClick={() => dispatch(ItemTypeAction.getAll({}, true))}>
              <i className='fa fa-spinner mr-2' /> {t('refresh')}
            </Button>
          </>
        }
      />
      <AddDialog
        title={
          editData
            ? `${t('edit')} ${t('information_other_item_type.item_type')}`
            : t('information_other_item_type.create_new_item_type')
        }
        editData={editData}
        modalOpen={modalOpen}
        onToggle={(open) => setModalOpen(open)}
        onSubmit={(values) => {
          setModalOpen(false);
          if (editData) dispatch(ItemTypeAction.update({ ...values, itemId: editData?._id }));
          else dispatch(ItemTypeAction.save(values));
          setTimeout(() => dispatch(ItemTypeAction.getAll({}, true)), 1000);
        }}
      />
      <ConfirmDialog
        modalOpen={showDelete}
        title={`${t('delete')} ${t('information_other_item_type.item_type')}`}
        body={`Are you sure to delete ${editData?.name}?`}
        onToggle={() => setShowDelete(false)}
        onConfirm={() => {
          setShowDelete(false);
          dispatch(ItemTypeAction.deleteData(editData?._id));
          setTimeout(() => dispatch(ItemTypeAction.getAll({}, true)), 1000);
        }}
      />
    </>
  );
}

export default ItemType;
